import { bootstrapApplication } from '@angular/platform-browser';
import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';
import { appConfig } from './app/app.config';
import { App } from './app/app';

ModuleRegistry.registerModules([AllCommunityModule]);

// AG-Grid v32+ enables `reactiveCustomComponents` by default, which disables
// function-style cellRenderers that return HTML strings. Our grids rely on those
// string renderers (badges, callnote link, category icon, etc.), so we opt out globally.
provideGlobalGridOptions({ reactiveCustomComponents: false });

// EB-3798: pre-DI bootstrap catch — LoggingService not injectable here.
bootstrapApplication(App, appConfig).catch((err) => console.error(err));
